/* Cosey Cart-Nudges: aktualisiert Gratis-Versand- & Mengenrabatt-Hinweise bei AJAX-Cart-Aenderungen (Drawer + Warenkorbseite). */
(function () {
  'use strict';
  var THRESHOLD = 2000; // 20 EUR in Cent
  var containers = function () { return document.querySelectorAll('[data-cosey-nudges]'); };
  if (!document.querySelector('[data-cosey-nudges]')) return;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function render(cart) {
    var html = '';
    if (cart.item_count > 0) {
      if (cart.total_price >= THRESHOLD) {
        html += '<div class="cosey-nudge cosey-nudge--shipping"><span class="cosey-nudge__icon cosey-nudge__icon--ok">✓</span> Gratis-Versand freigeschaltet (DE)</div>';
      } else {
        var missing = THRESHOLD - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price * 100 / THRESHOLD));
        html += '<div class="cosey-nudge cosey-nudge--shipping"><span class="cosey-nudge__icon">🚚</span> Noch <strong>' + money(missing) + '</strong> bis zum Gratis-Versand (DE)<div class="cosey-nudge__bar"><span style="width:' + pct + '%"></span></div></div>';
      }
      var leggings = 0;
      (cart.items || []).forEach(function (i) {
        if ((i.product_title || '').indexOf('Leggings') !== -1) leggings += i.quantity;
      });
      if (leggings === 1 || leggings === 2) {
        var need = 3 - leggings;
        html += '<div class="cosey-nudge cosey-nudge--deal"><span class="cosey-nudge__icon">🏷️</span> Noch <strong>' + need + ' Legging' + (need > 1 ? 's' : '') + '</strong> – ab 3 Leggings gibt’s automatisch Mengenrabatt</div>';
      } else if (leggings >= 3 && cart.total_discount > 0) {
        html += '<div class="cosey-nudge cosey-nudge--deal cosey-nudge--active"><span class="cosey-nudge__icon cosey-nudge__icon--ok">✓</span> Rabatt aktiv – du sparst <strong>' + money(cart.total_discount) + '</strong></div>';
      }
    }
    containers().forEach(function (el) { el.innerHTML = html; });
  }

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 350);
  }

  // AJAX-Cart-Aenderungen abfangen (fetch + XHR), danach Nudges aktualisieren
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_RE.test(url)) p.then(refresh, function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(url || '')) {
      this.addEventListener('loadend', refresh);
    }
    return _open.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
